import _RemarkEmoji from 'remark-emoji'

export const remarkPlugins = {
  'remark-emoji': { instance: _RemarkEmoji },
}

export const rehypePlugins = {
}

export const highlight = {}